document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth < 990) return;

  const detailsElements = document.querySelectorAll(
    'header details'
  );

  detailsElements.forEach((details) => {
    const summary = details.querySelector('summary');

    details.addEventListener('mouseenter', () => {
      details.setAttribute('open', true);
    });

    details.addEventListener('mouseleave', () => {
      details.removeAttribute('open');
    });
  });
});
